import Loadable from "../../components/Loadable";
import { lazy } from "react";
import { REPORTS } from "../../utils/constant";

const CustomReport = Loadable(lazy(() => import("./CustomReport")));
const StatusReport = Loadable(lazy(() => import("./StatusReport")));
const StatusWiseReport = Loadable(lazy(() => import("./StatusWiseReport")));
const ExcecutiveWiseReport = Loadable(lazy(() => import("./ExcecutiveWiseReport")));
const ReportsDashboard = Loadable(lazy(() => import("./ReportsDashboard")));
const EmployeeTargetsReport = Loadable(lazy(() => import("./EmployeeTargetsReport")));
const TaskAnalysisReport = Loadable(lazy(() => import("./TaskAnalysisReport")));
const EmployeePerformanceReport = Loadable(lazy(() => import("./EmployeePerformanceReport")));

const reportRoutes = [
  {
    path: "/report/dashboard",
    element: <ReportsDashboard />,
    permission: REPORTS,
  },
  {
    path: "/report/report",
    element: <CustomReport/>,
    permission: REPORTS,
  },
  {
    path: "/report/statusReport",
    element: <StatusReport/>,
    permission: REPORTS,
  },
  {
    path: "/report/statusWiseReport",
    element: <StatusWiseReport/>,
    permission: REPORTS,
  },
  {
    path: "/report/ExecutiveWiseReport",
    element: <ExcecutiveWiseReport/>,
    permission: REPORTS,
  },
  {
    path: "/report/employee-targets",
    element: <EmployeeTargetsReport />,
    permission: REPORTS,
  },
  {
    path: "/report/task-analysis",
    element: <TaskAnalysisReport />,
    permission: REPORTS,
  },
  {
    path: "/report/employee-performance",
    element: <EmployeePerformanceReport />,
    permission: REPORTS,
  },
];
export default reportRoutes;
